import { googleSdkLoaded, googleLogout, type CallbackTypes } from "vue3-google-login";
import { createAccountSetupLink, router } from "@/router";
import { UserNotEstablishedException } from "../../../userExceptions";
import { gettext } from "@/services/translation";
import { Event, EventBus } from "@/services/eventBus";
import { Authentication, setupUserInApp } from "@/services/user/auth/login";
import { thirdPartyLogin } from "@/services/user/auth/login/sso/api";
import { LoginProvider, ThirdPartyLoginStatus } from "@/services/user/auth/login/sso/types";
import { afterLogin } from "@/services/user/auth/login/afterLoginService";

const GoogleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const GoogleNotDisplayedReasonNoSession = "opt_out_or_no_session";
let subscribeNewsletter = false;

export function login(registerNewsletter: boolean): void {
  subscribeNewsletter = registerNewsletter;
  initGoogle();
  openWindow();
}

export function logout(): void {
  googleLogout();
}

function initGoogle(): void {
  googleSdkLoaded((google) => {
    google.accounts.id.initialize({
      client_id: GoogleClientId,
      cancel_on_tap_outside: false,
      callback: handleLogin,
    });
  });
}

function openWindow(): void {
  googleSdkLoaded((google) => {
    google.accounts.id.prompt((notification: google.accounts.id.PromptMomentNotification) => {
      const notDisplayedReason = notification.getNotDisplayedReason();
      if (notDisplayedReason === GoogleNotDisplayedReasonNoSession) {
        console.info("Google prompt(): Branch 1");
        const msg = gettext.$gettext("Nepodařilo se vytvořit Google přihlášení. Máte povoleno vytváření cookies?");
        EventBus.emit({ event: Event.ToastError, data: msg });
      } else if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        console.info("Google prompt(): Branch 2");
        document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
        google.accounts.id.prompt();
      }
    });
  });
}

async function handleLogin(response: CallbackTypes.CredentialPopupResponse): Promise<void> {
  const text = gettext.$gettext("Kontroluji údaje...");
  EventBus.emit({ event: Event.ShowTextOverlay, data: text });

  const token = response.credential;

  const loginResponse = await thirdPartyLogin(token, subscribeNewsletter, LoginProvider.Google);
  EventBus.emit({ event: Event.HideTextOverlay });

  if (loginResponse.status === ThirdPartyLoginStatus.Ok) {
    const { user } = loginResponse;

    Authentication.resolveManually(); // Prevent re-authentication
    setupUserInApp(user)
      .then(afterLogin)
      .catch((e: unknown) => {
        if (e instanceof UserNotEstablishedException) {
          const redirect = createAccountSetupLink();
          router.push(redirect);
        } else {
          throw e;
        }
      });
  } else {
    EventBus.emit({ event: Event.ToastError, data: loginResponse.message });
  }
}
